import React from "react";
import { round } from "lodash";
import convertToRiR from "../../../../utils/converters/convert-intensity";
import {
  getLiftsSetsVolume,
  getPeakValues,
  getWeightedIntensity,
  getWeightedRpe,
  hasRpe,
} from "../../../../utils/actuals";

const ExerciseMetrics = (props) => {
  const {
    exercise,
    fromMetric,
    withWeight,
    units,
    isProgramEditor,
    isRiR,
    intensityMeasure,
  } = props;

  if (isProgramEditor) return null;

  const { lifts, sets, volume, rpeVolume } = getLiftsSetsVolume(exercise);
  const {
    e1rm: peakE1rm,
    intensity: peakIntensity,
    rpe: peakRpe,
  } = getPeakValues(exercise);
  const avgIntensity = getWeightedIntensity(exercise, volume);
  const avgRpe = getWeightedRpe(exercise, rpeVolume);

  const showRpe = hasRpe(exercise);
  const showRM = exercise.type === "primary" || exercise.type === "secondary";

  return (
    <li className="exercise-metrics-container">
      <div>
        <span className="title">Volume</span>
        <span className="value">
          {volume
            ? withWeight(
                round(fromMetric(volume, units, false), 1),
                units,
                false
              )
            : "-"}
        </span>
      </div>
      <div>
        <span className="title">Top e1RM</span>
        <span className="value">
          {peakE1rm
            ? withWeight(
                round(fromMetric(peakE1rm, units, false), 1),
                units,
                false
              )
            : "-"}
        </span>
      </div>
      <div>
        <span className="title"># of Lifts</span>
        <span className="value">{lifts || "-"}</span>
      </div>
      <div>
        <span className="title"># of Sets</span>
        <span className="value">{sets || "-"}</span>
      </div>
      {!!showRpe && !!avgRpe && (
        <div>
          <span className="title">Avg {intensityMeasure}</span>
          <span className="value">
            {convertToRiR(round(avgRpe, 1), !isRiR)}
          </span>
        </div>
      )}
      {!!showRpe && !!peakRpe && (
        <div>
          <span className="title">Top {intensityMeasure}</span>
          <span className="value">{convertToRiR(peakRpe, !isRiR)}</span>
        </div>
      )}
      {!!showRM && !!avgIntensity && (
        <div>
          <span className="title">Avg %1RM</span>
          <span className="value">{`${round(avgIntensity * 100, 1)}%`}</span>
        </div>
      )}
      {!!showRM && !!peakIntensity && (
        <div>
          <span className="title">Top %1RM</span>
          <span className="value">{`${round(peakIntensity * 100, 1)}%`}</span>
        </div>
      )}
    </li>
  );
};

export default ExerciseMetrics;
